import Vue from "vue"
import Router from "vue-router"
import UpgradingExamRegister from "@/views/stepper/upgrading-exam-register"
import UpgradingExamCorrect from "@/components/upgrading-exam-correct"
import UpgradingExamCenter from "@/components/upgrading-exam-center"
import UpgradingExamPaper from "@/components/upgrading-exam-paper-active"
import UpgradingExamPaperOnline from "@/components/upgrading-exam-online-paper-active"
import NotFound from "@/views/global/404"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      name: "upgrading-examination-register",
      component: UpgradingExamRegister
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/examination/application/correct/:token",
      name: "upgrading-examination-correct",
      component: UpgradingExamCorrect
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/examination/application/center/:token",
      name: "upgrading-examination-center",
      component: UpgradingExamCenter
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/exam/application/papers/:token",
      name: "upgrading-examination-application-papers",
      component: UpgradingExamPaper
      //meta: { requiresAuth: true }
    },
    {
      path: "/online-exam/application/papers/:token",
      name: "upgrading-online-examination-application-papers",
      component: UpgradingExamPaperOnline
      //meta: { requiresAuth: true }
    },
    {
      path: "*",
      name: "not-found",
      component: NotFound
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js